// extracted by mini-css-extract-plugin
export var banner = "_du-0";
export var closeButton = "_du-2";
export var greenCheckmark = "_du-3";
export var hereLink = "_du-4";
export var titleIcon = "_du-1";